/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignedAgentId
 */
export interface AssignedAgentId {
}

/**
 * Check if a given object implements the AssignedAgentId interface.
 */
export function instanceOfAssignedAgentId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AssignedAgentIdFromJSON(json: any): AssignedAgentId {
    return AssignedAgentIdFromJSONTyped(json, false);
}

export function AssignedAgentIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignedAgentId {
    return json;
}

export function AssignedAgentIdToJSON(value?: AssignedAgentId | null): any {
    return value;
}

